declare const Phaser: any;

import { BaseScene } from "../../framework/BaseScene";

export class TreasureScene extends BaseScene {
  constructor() {
    super({ key: "TreasureScene" });
  }

  onReady(_data?: any): void {
    this.add.rectangle(400, 225, 800, 450, 0x1a1a2e);

    this.add.text(400, 60, "TREASURE", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "32px",
      color: "#fbbf24",
      fontStyle: "bold",
    }).setOrigin(0.5);

    this.add.text(400, 160, "You found a chest!", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "16px",
      color: "#d1d5db",
    }).setOrigin(0.5);

    // Chest icon
    this.add.rectangle(400, 220, 60, 40, 0x92400e);
    this.add.rectangle(400, 215, 64, 6, 0xb45309);
    this.add.circle(400, 225, 4, 0xfbbf24);

    // Collect button
    const btn = this.add.rectangle(400, 320, 140, 40, 0xb45309);
    btn.setStrokeStyle(2, 0xd97706);
    btn.setInteractive({ useHandCursor: true });
    this.add.text(400, 320, "COLLECT", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      color: "#ffffff",
      fontStyle: "bold",
    }).setOrigin(0.5);

    btn.on("pointerdown", () => {
      this.sm.pop({ outcome: "collected", gold: 25 });
    });
  }

  onUpdate(_time: number, _delta: number): void {}
}
